import React from "react";
import styled, { css } from "styled-components";

import { useTheme } from "@mui/styles";
import ReturnsSlice5 from "../Returns/ReturnsSlice5";
import { SlideContainer } from "./OurCommitment.styles";



const FormBox = styled.div`
`;
const OurCommitmentSlide6 = () => {
  const theme = useTheme();
  return (
    <SlideContainer style={{padding:"0px 20px 20px 20px"}}>

      <FormBox>
        <ReturnsSlice5
          title={"Have Questions About Recycling? Send Us A Message Below!"}
          headerStyles={{
            width: "100%",
          }}
          fontColor={theme.COLORS.WHITE.backgroundWhite}
          background={theme.COLORS.GREEN.lightGreen}
        />
      </FormBox>
    </SlideContainer>
  );
};

export default OurCommitmentSlide6;
